export { WhiteLabelFooter } from './components/white-label-footer/white-label-footer';
export { type WhiteLabelFooterProps } from './components/white-label-footer/white-label-footer.types';
